import React, { ChangeEvent, KeyboardEvent } from 'react';
import styles from './SearchField.module.scss';
import { SearchIcon } from '../../assets/icons/SearchIcon';

export interface ISearchFieldProps {
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
  isDisabled: boolean;
  placeholder: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const SearchField = ({ onKeyDown, isDisabled, placeholder, onChange }: ISearchFieldProps) => {
  return (
    <div className={styles['input-wrapper']}>
      <SearchIcon className={styles['icon']} />
      <input
        type="search"
        placeholder={placeholder}
        className={styles['input']}
        onKeyDown={onKeyDown}
        disabled={isDisabled}
        data-cy="search-field"
        onChange={onChange}
      />
    </div>
  );
};

export default SearchField;
